const cardsList = document.querySelector('.grid-wrapper--related_products .grid-cards');
const cards = cardsList?.querySelectorAll('.card-product');

const config = {
	max: 3
};

const shuffleCards = () => {
	const array = Array.from(cards);

	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}

	return array;
};

if (cardsList && cards.length > config.max) {
	const shuffledCards = shuffleCards(cards);

	shuffledCards.forEach(card => cardsList.appendChild(card));
	shuffledCards.slice(config.max).forEach(card => card.remove());
}
